import { Injectable } from '@angular/core';
import firebase from 'firebase';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root'
})
export class PhoneVerificationService {

  constructor(private windowService:WindowService) { }

  recaptchaVerifier() {
    this.windowService.windowRef.recaptchaVerifier =
      new firebase.auth.RecaptchaVerifier("recaptcha-container", {
        size: "invisible",
      });
  }
}
